<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Daily Pickup Report</strong>

          </div>
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>
              <b-col sm="4">
                <b-form-group label="From Date:" :label-cols="3">
                  <v-date-picker mode='single' input-class="dateInput"
                    :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label="To Date:" :label-cols="3">
                  <v-date-picker mode='single' input-class="dateInput"
                    :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <div id='container'>
                  <b-form-group label="Warehouse ID" :label-cols="4">
                    <div id='container'>
                      <ejs-multiselect id='multi_select2' placeholder="Select WareHouse" v-model="valueWH"
                        :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All"
                        unSelectAllText="unSelect All" :fields='fieldWH' :allowCustomValue='allowCustomValue'
                        enableGroupCheckBox="true" mode="CheckBox"></ejs-multiselect>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12" class="my-1 text-right">

                <b-form-group>
                  <b-button type="submit" size="md" variant="primary" @click="showCSV(1)"> Search</b-button>

                  <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px">
                    clear</b-button>

                  <b-button v-if="totalRows > 0" type="submit" variant="primary" size="md" style="margin-left:20px;"
                    @click="downloadCSV">Download </b-button>

                </b-form-group>

              </b-col>
            </b-row>
            <b-row>

              <b-col sm="12" class="text-right  margin-bottom =-13px;">
                <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> &nbsp;&nbsp;&nbsp;
              </b-col>
            </b-row>
          </b-form>

          <b-col sm="12" style="overflow:auto;">


            <table class=" b-table table-bordered">
              <thead>

                <tr>
                  <th>WH ID</th>
                  <th>Origin Name</th>
                  <th>Stockist State</th>
                  <th>PickDone App(Load Count)</th>
                  <th>PickDone Manual(Load Count)</th>
                  <th>PickDone Total(Load Count)</th>
                  <th>PickDone Total(Box Count)</th>
                  <th>Vehicle No.</th>
                  <th>Pickup Pending(Box Count)</th>
                  <th>Pickup Shortage</th>
                  <th>Pickup Damage</th>
                  <th>NPR</th>
                  <th>Pickup Date & Time</th>
                  <th>Trip</th>
                  <th>Hubinscan Total(Load Count)</th>
                  <th>Hubinscan Total(Box Count)</th>
                  <th>Hubinscan Shortage</th>
                  <th>Hubinscan Damage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :class="getRowClass(item)">
                  <td>{{ item.warehouseid }}</td>
                  <td>{{ item.sourcecompanyname }}</td>
                  <td>{{ item.sourcestate }}</td>
                  <td>{{ item.pickdoneappcount }}</td>
                  <td>{{ item.pickdonemanualcount }}</td>
                  <td>{{ item.pickdonetotalloadcount }}</td>
                  <td>{{ item.pickdoneboxcount }}</td>
                  <td>{{ item.vehicleno }}</td>
                  <td>{{ item.pickuppendingCount }}</td>
                  <td>{{ item.pickdoneshortagecount }}</td>
                  <td>{{ item.pickdonedamagecount }}</td>
                  <td>{{ item.nprCount }}</td>
                  <td>{{ item.actualpickupdatetime }}</td>
                  <td>{{ item.tripcountno }}</td>
                  <td>{{ item.hubinscanloadcount }}</td>
                  <td>{{ item.hubinscanboxcount }}</td>
                  <td>{{ item.hubinscanshortagecount }}</td>
                  <td>{{ item.hubinscandamagecount }}</td>
                </tr>
                <tr v-if="items.length === 0">
                  <td colspan="18" class="text-center">No Records Found</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function () {
    return {
      data: [],
      items: [],
      selected: '',
      isBusy: false,
      email: '',
      hubid: '',
      data1: [],
      // perPage:  10,
      pageNum: 1,
      noofpages: '',
      pageOptions: [5, 10, 15],
      sortBy: true,
      awbno: '',
      agentmaster: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo: new Date(),
      hubdata: [],
      details: [],
      progressbar: [],
      orderid: [],
      foodproduct: '',
       selected_origin : '',
      fields: [
        // { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
        { key: 'warehouseid', label: 'WH ID', sortable: true, sortDirection: 'desc' },

        { key: 'sourcecompanyname', label: 'Origin Name', sortable: true, sortDirection: 'desc' },
        { key: 'sourcestate', label: 'Stockist State', sortable: true },
        { key: 'pickdoneappcount', label: 'PickDone App(Load Count)', sortable: true, sortDirection: 'desc' },
        { key: 'pickdonemanualcount', label: 'PickDone Manual(Load Count)', sortable: true, sortDirection: 'desc' },
        { key: 'pickdonetotalloadcount', label: 'PickDone Total(Load Count)', sortable: true },
        { key: 'pickdoneboxcount', label: 'PickDone Total(Box Count)', sortable: true },
        { key: 'vehicleno', label: 'Vehicle No.', sortable: true },
        { key: 'pickuppendingCount', label: 'Pickup Pending(Box Count)', sortable: true },
        { key: 'pickdoneshortagecount', label: 'Pickup Shortage', sortable: true },
        { key: 'pickdonedamagecount', label: 'Pickup Damage', sortable: true },
        { key: 'nprCount', label: 'NPR', sortable: true },
        { key: 'actualpickupdatetime', label: 'Pickup date & Time', sortable: true },
        { key: 'tripcountno', label: 'Trip', sortable: true },
        { key: 'hubinscanloadcount', label: 'Hubinscan Total(Load Count)', sortable: true },
        { key: 'hubinscanboxcount', label: 'Hubinscan Total(Box Count)', sortable: true },
        { key: 'hubinscanshortagecount', label: 'Hubinscan Shortage', sortable: true },
        { key: 'hubinscandamagecount', label: 'Hubinscan Damage', sortable: true },
      ],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
      perPage: 150,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      outlined: true,
      sortDirection: 'asc',
      filter: null,
      valueWH: [],
      fieldWH: { text: 'name', value: 'id' },
      optionsWH: [],
      WHData: [],
      showSelectAll: false,
      searching: '',
      awbno: '',
      deliverystatus: '',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      selected_normalorasn: 'rocketbees',
      mpsloadoptions: [
        { value: 'rocketbees', text: 'RocketBees' },
        { value: 'rocketbees_vendor', text: 'RocketBees Vendor' }]
    };
  },
  created: function () {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.email = userInfo.sysemailid;
    this.showCSV(this.pageNum);
    this.showWHlist();
    this.origindata();
  },
  methods: {
    getRowClass(item) {
    if ((item.pickdoneboxcount != item.hubinscanboxcount) || (item.pickdoneshortagecount != item.hubinscanshortagecount)) {
      return 'highlighted';
    }
    return 'normal';
  },
    selected_originInfo:function(value){
            if (value==null) {
              // this.selected_vehicleno="";
              this.origindata()
            
            }
        },
    checklenght(value) {
      console.log("value", value)
      if (value.length == 0) {
        this.searching = []
        this.totalRows = 0
        this.showCSV(this.pageNum)
      }
    },
    info(item, shipmentid, index, button) {
      this.progressbar = item;
      this.infoModal.title = 'Shipment Log - ' + shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) { },


    clickCallback(pageNum) {

      this.showCSV(pageNum);
    },
    showCSV: function (pagee) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isBusy = true;
      var warehouseid = (this.valueWH.length > 0) ? this.valueWH : "";
      //console.log('this.selected_origin.key---------', this.selected_origin.key);
      var hubid = (this.selected_origin && this.selected_origin !== null && this.selected_origin.key) ? this.selected_origin.key : "";
      var email = this.email;
      //var fromdate = (this.selectDateFrom != null) ? this.formatDate(this.selectDateFrom) : "";
      //var formatdateto = (this.selectDateTo != null) ? this.formatDate(this.selectDateTo) : "";
      var fromdate = (this.selectDateFrom != null) ? this.formatDate(this.selectDateFrom) + " 00:00:00" : "";
      var formatdateto = (this.selectDateTo != null) ? this.formatDate(this.selectDateTo) + " 23:59:59" : "";

      // var deliverystatus = (this.deliverystatus != null) ? this.deliverystatus : "";
      var csvObj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        fromdate: `${fromdate}`,
        todate: `${formatdateto}`,
        email: `${this.email}`,
        page_no: pagee,
        search_text: this.searching,
        // deliverystatus: deliverystatus,
        warehouseid: warehouseid,
        hubid: hubid,
        // load_movement: this.selected_normalorasn,
      };

console.log("csvObj----@@@@@@@@@@@@@@@@>",csvObj);

      if (formatdateto < fromdate) {
        this.$fire({
          text: "To date need to be greater than From date",
          type: "warning",
          timer: 30000
        });
        this.isBusy = false;
        return false;
      }
      console.log("csvObj", csvObj);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDailyPickupReportListing`, csvObj)
        .then(result => {
          console.log("result----@@@@@@@@@@@@@@@@>",result);
          this.isBusy = false;

          if (result.body.returnmsg === 'Successful') {
            this.items = result.body.returnvalue[0].parentawblistlist;
            console.log('this.items@@@@@@@@@@@@@@@@', this.items);
            this.totalRows = result.body.returnvalue[0].totalrecords;

            this.noofpages = parseInt(this.totalRows) / 20;

            this.noofpages = Math.ceil(this.noofpages);
          } else {
            this.showdata = []
            this.items = [];
            this.totalRows = 0;

          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },

    downloadCSV: function () {
       document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      // this.isBusy = true;

      // var email=this.email;
      var warehouseid = (this.valueWH.length > 0) ? this.valueWH : "";
      //var fromdate = (this.selectDateFrom != null) ? this.formatDate(this.selectDateFrom) : "";
      //var formatdateto = (this.selectDateTo != null) ? this.formatDate(this.selectDateTo) : "";
      var deliverystatus = (this.deliverystatus != null) ? this.deliverystatus : "";
      var hubid = (this.selected_origin && this.selected_origin !== null && this.selected_origin.key) ? this.selected_origin.key : "";
      var fromdate = (this.selectDateFrom != null) ? this.formatDate(this.selectDateFrom) + " 00:00:00" : "";
      var formatdateto = (this.selectDateTo != null) ? this.formatDate(this.selectDateTo) + " 23:59:59" : "";
      var csvObj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        fromdate: `${fromdate}`,
        todate: `${formatdateto}`,
        // deliverystatus: deliverystatus,
        warehouseid: warehouseid,
        hubid: hubid,
        // email:`${this.email}`,
        // page_no:pagee,
        search_text: this.searching,
        // load_movement: this.selected_normalorasn,
        // sysusermasterid:`${userInfo.sysusermasterid}`
      };
      console.log("JJJJJ", csvObj);
      // return false;
      if (formatdateto < fromdate) {
        this.$fire({
          text: "To date need to be greater than From date",
          type: "warning",
          timer: 30000
        });
        document.getElementById("overlay").style.display = "none";
        // this.isBusy = false; 
        return false;
      }
      // console.log("csvObj",csvObj);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDailyPickupCSVReportNew`, csvObj)
        .then(result => {

          document.getElementById("overlay").style.display = "none";
          if (result.body == "success") {
            // alert("Please Check Ur Mail For Downlod Link")
            this.$fire({
              text: "Please Check Your Mail For Downlod Link",
              type: "success",
              timer: 30000
            });
          }
          else {
            this.$fire({
              text: "Can not Download",
              type: "error",
              timer: 30000
            });
            // alert("Can not Download");
          }

        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },

    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null; var ce
      }


      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";

      //.slice(0,-4)
      keys = Object.keys(data[0]);

      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function (item) {
        var logdata = item['logdata'];
        var attempt = item['attempt'];
        var allowcheckedin = item['allowcheckedin']

        item['pickupcheckintime'] = null;
        item['pickuptime'] = null;

        item['orderconfirmedtime'] = null;
        item['deliverytime'] = null;
        item['ordercreationtimestamp'] = "'" + item['ordercreationtimestamp'];
        item['scheduledstarttime'] = "'" + item['scheduledstarttime'];
        item['scheduledendtime'] = "'" + item['scheduledendtime'];

        if (logdata !== null) {

          logdata.forEach(function (itm) {
            let mydate = new Date(itm.createddate);
            let month = mydate.getMonth() + 1;
            let createddate = "'" + mydate.getFullYear() + "-" + month + "-" + mydate.getDate() + " " + mydate.getHours() + ":" + mydate.getMinutes();
            switch (itm.process) {
              case 'BookingDone':
                if (attempt !== null) {
                  if (attempt == itm.attempt) {
                    item['orderconfirmedtime'] = createddate.toString();
                    break;
                  }
                } else {
                  item['orderconfirmedtime'] = createddate.toString();
                  break;
                }
              case 'OFD':
                if (attempt !== null) {
                  if (attempt == itm.attempt) {
                    if (allowcheckedin == 'true') {
                      item['pickupcheckintime'] = item['pickupcheckintime1'];
                      item['pickuptime'] = createddate.toString();
                      break;
                    } else {

                      item['pickupcheckintime'] = createddate.toString();
                      item['pickuptime'] = createddate.toString();
                      break;
                    }
                  }
                } else {
                  if (allowcheckedin == 'true') {
                    item['pickupcheckintime'] = item['pickupcheckintime1'];
                    item['pickuptime'] = createddate.toString();
                    break;
                  } else {
                    item['pickupcheckintime'] = createddate.toString();
                    item['pickuptime'] = createddate.toString();
                    break;
                  }
                }
              case 'DLV':
                if (attempt !== null) {
                  if (attempt == itm.attempt) {
                    if (allowcheckedin == 'true') {
                      item['deliverycheckintime'] = item['deliverycheckintime1'];
                      item['deliverytime'] = createddate.toString();
                      break;
                    } else {
                      item['deliverycheckintime'] = createddate.toString();
                      item['deliverytime'] = createddate.toString();
                      break;
                    }
                  }
                } else {
                  if (allowcheckedin == 'true') {
                    item['deliverycheckintime'] = item['deliverycheckintime1'];
                    item['deli var ceverytime'] = createddate.toString();
                    break;
                  } else {
                    item['deliverycheckintime'] = createddate.toString();
                    item['deliverytime'] = createddate.toString();
                    break;
                  }
                }

              case 'NDR':
                if (attempt !== null) {
                  if (attempt == itm.attempt) {
                    item['deliverycheckintime'] = null;
                    item['deliverytime'] = null;
                    break;
                  }
                } else {
                  item['deliverycheckintime'] = null;
                  item['deliverytime'] = null;
                  break;
                }
            }
          });
        } else {
          item['deliverytime'] = '';
          item['orderconfirmedtime'] = '';
          item['pickupcheckintime'] = '';
          item['pickuptime'] = '';
        }
        ctr = 0;


        keys.forEach(function (key) {
          // console.log('--------------------');
          // console.log(key);
          //       console.log('-----datta---------------');
          //&& key!='logdata'
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null && key != 'logdata') {

            if (key == 'origin') {
              var str2 = item[key];
              str2 = str2.replace('#', '');
              result += '"' + str2 + '"';
            } else {
              result += '"' + item[key] + '"';
            }
          }

          ctr++;
        });
        result += lineDelimiter;
      });
      //  document.getElementById("loader").style.display = 'none';

      return result;
    },
    formatDate: function (date) {
       var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
    clear: function () {
      this.searching = "";
      this.deliverystatus = "";
      this.selectDateFrom = new Date();
      this.selectDateTo = new Date();
      this.valueWH = [];
      this.filter = "";
      this.selected_origin = "";
      this.selected_normalorasn = 'rocketbees';
      this.showCSV(this.pageNum);
    },
    showWHlist: function () {

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      var csvObj = {};
      // console.log("JJJJJ", csvObj);
      // return false;
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
        .then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsWH = [];
            this.WHData = result.body.returnvalue;
            // console.log("HHHHHHH", this.WHData)
            for (let j = 0; j < this.WHData.length; j++) {
              let WH = {
                name: this.WHData[j].warehouseid + " - " + this.WHData[j].warehousename,
                id: this.WHData[j].warehouseid,
              }
              // console.log("hjjjjj", WH.name);
              this.optionsWH.push(WH);
              // console.log("optionsWH", this.optionsWH);
            }
          } else {
            this.WHData = result.body.returnvalue;
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },
       origindata: function() {
        // this.isBusy = true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const deliveryagentobj = {
          sysusermasterid:`${userInfo.sysusermasterid}`
        };
        console.log('deliveryagentobj',deliveryagentobj);
        this.$http
          .post(
            `${
              CONSTANTS.MIGRATION_API_URL
            }/getOriginList`,
            deliveryagentobj
          )
          .then(result => {

            if (result.body.returnvalue.length > 0) {
              this.data = result.body.returnvalue;
              var data = [];

              this.data.forEach(function (srData) {
                data.push({
                key:srData.hub_id,
                label:srData.hub_title
                });
            });
            this.originitems = data;

            } else {
              // this.isBusy = !this.isBusy
              this.data = result.body;
              this.originitems  = result.body;
              // this.totalRows = result.body.length
            }
            
          })
          .catch(ex => {
            console.log("error", ex);
          });
      
    },
  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}

.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}

.table tr th {
  color: #fff !important;
  padding: .2rem !important;
}

.table thead,
.table thead tr:hover {
  background: #333 !important;
}

.table button {
  background: #b0c4de !important;
  color: #000 !important;
}

.table tr:hover {
  background: #efefef;
}

tbody tr:nth-child(even) {
  background: #f2f2f2;
}

tbody tr:nth-child(odd) {
  background: #fff;
}

.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}

hr {
  margin-bottom: 0px;
}

.error {
  color: red;
}

button.editbtn {
  border: none;
  background: transparent !important;
}

.label {
  text-align: left;
}

.select {
  width: 100%;
}

.nameOfTheClass {
  max-width: 450px !important;
}

.orderidClass {
  max-width: 110px !important;
}

.awbClass {
  max-width: 110px !important;
}

.statusClass {
  max-width: 110px !important;
}

.desitnationClass {
  max-width: 110px !important;
}

.countryClass {
  max-width: 60px !important;
}

.pickupClass {
  max-width: 100px !important;
}


/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.box-highlight {
  padding: 10px; /* Adjust as necessary */
  border-radius: 5px; /* Optional */
  transition: background-color 0.3s ease; /* Smooth transition */
}

.highlighted {
  background-color: yellow !important; /* Yellow for highlighting */
}

.normal {
  background-color: transparent !important; /* No color for normal rows */
}

.table thead tr th {
  z-index: 1;
}

/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
